export default __webpack_public_path__ + "static/media/FiraSans-Regular.f5516056.woff";